if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        document.body.classList.remove('overflowhidden');
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }

      show(opener) {
        super.show(opener);
        document.body.classList.add("overflowhidden");

        // ── Wait for owl carousel to be initialized before sliding ────────
        // Modal opens before initializeOwlCarousel completes on first open.
        // Poll until owl-loaded class appears then slide to correct image.
        var fullMediaId = window.lastViewedMediaId;
        if (!fullMediaId) return;

        var mediaId = fullMediaId.split("--").pop().split("__main-").pop();
        var $carousel = $(this.querySelector(".owl-carousel"));

        var interval = setInterval(function () {
          if (!$carousel.hasClass("owl-loaded")) return;

          var $items = $carousel.find(".owl-item [data-media-id]");
          var indexToSlide = 0;

          $items.each(function (index) {
            if (this.dataset.mediaId === mediaId) {
              indexToSlide = index;
              return false;
            }
          });

          $carousel.trigger("to.owl.carousel", [indexToSlide, 0, false]);
          clearInterval(interval);
        }, 30);
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`
        ).forEach((element) => {
          element.classList.remove("active");
        });
        var activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`
        );
        var activeMediaTemplate = activeMedia.querySelector("template");
        var activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add("active");
        activeMedia.scrollIntoView();

        var container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == "DEFERRED-MEDIA" &&
          activeMediaContent &&
          activeMediaContent.querySelector(".js-youtube")
        )
          activeMedia.loadContent();
      }
    }
  );
}

/*******************************************************
  Media gallery carousel
  Uses type="lazy-script" timing — Defer.all() fires on
  DOMContentLoaded but owl.js may not be ready yet on first
  run. initializeOwlCarousel polls for $.fn.owlCarousel
  availability before initializing.
*******************************************************/
(function () {
  var $carousel;

  window.initializeOwlCarousel = function () {
    // ── Poll until owl.js is loaded ───────────────────────────────────
    // owl.js is type="lazy-script" so it may not be available
    // immediately when this script executes. Poll every 20ms
    // until $.fn.owlCarousel exists then initialize.
    function tryInit() {
      if (typeof $.fn.owlCarousel === 'undefined') {
        setTimeout(tryInit, 20);
        return;
      }

      $carousel = $('.owl-modal-slider');

      if (!$carousel.length) return;

      // Destroy existing instance if reinitializing
      if ($carousel.data('owl.carousel')) {
        $carousel.trigger('destroy.owl.carousel');
        $carousel.removeClass('owl-carousel owl-loaded');
      }

      $carousel.owlCarousel({
        loop: false,
        dots: false,
        margin: 0,
        nav: true,
        dragEndSpeed: 600,
        mouseDrag: true,
        touchDrag: true,
        responsive: {
          0:    { items: 1 },
          600:  { items: 1 },
          1000: { items: 1 }
        }
      });

      $carousel.on('changed.owl.carousel', function (event) {
        var currentIndex = event.item.index;
        var $currentItem = $(event.target)
          .find('.owl-item')
          .eq(currentIndex)
          .find('[data-media-id]');

        if ($currentItem.length) {
          window.lastViewedMediaId = $currentItem.attr('data-media-id');
        }
      });
    }

    tryInit();
  };

  // ── Initialize on first load ──────────────────────────────────────
  window.initializeOwlCarousel();

  // ── Sync main gallery when modal closes ──────────────────────────
  function syncGalleryToLastViewed() {
    var mediaGallery = document.querySelector('media-gallery');
    var lastMediaId = window.lastViewedMediaId;

    if (!mediaGallery || !lastMediaId) return;

    var items = mediaGallery.querySelectorAll('[data-media-id]');
    var lastPart = lastMediaId.split('-').pop();

    var match = Array.from(items).find(function (el) {
      return el.dataset.mediaId === lastMediaId ||
        (el.dataset.mediaId && el.dataset.mediaId.endsWith(lastPart));
    });

    if (match) {
      mediaGallery.setActiveMedia(match.dataset.mediaId, false);
    }
  }

  document.body.addEventListener('modalClosed', syncGalleryToLastViewed);
})();